export default __webpack_public_path__ + "6fbc599decefa1312ca289937c2a0c51.jpg";